(function () {
    "use strict";

    function docReady(fn) {
        // see if DOM is already available
        if (
            document.readyState === "complete" ||
            document.readyState === "interactive"
        ) {
            // call on next available tick
            setTimeout(fn, 1);
        } else {
            document.addEventListener("DOMContentLoaded", fn);
        }
    }

    docReady(function () {
        // DOM is loaded and ready for manipulation here
        function setCookie(cname, cvalue, exdays) {
            const d = new Date();
            d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
            let expires = "expires=" + d.toUTCString();
            document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        }

        function getCookie(cname) {
            let name = cname + "=";
            let ca = document.cookie.split(";");
            for (let i = 0; i < ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) == " ") {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        }

        const moreIndustries = document.querySelector(".more-industries-link");
        if (moreIndustries) {
            moreIndustries.addEventListener("click", function (e) {
                const elem = e.currentTarget;
                const elemSpan = e.currentTarget.querySelector("span");
                if (elem.classList.contains("collapsed")) {
                    elemSpan.innerHTML = elem.dataset.collapsedtext;
                } else {
                    elemSpan.innerHTML = elem.dataset.opentext;
                }
            });
        }

        const mobileIndustries = document.querySelector(".mobile-industries");
        const mobileQuestion = document.querySelector(".mobile-question");
        const unselectedIndustries = document.querySelector(
            ".unselected-industries"
        );
        const industryButtons = document.querySelectorAll(
            ".unselected-industries a.btn"
        );
        const selectedIndustries = document.querySelector(
            ".selected-industries"
        );

        const industrySlideoutTitle = document.querySelector(
            ".industry-slideout-title"
        );

        const resetIndustries = document.querySelector(".reset-industries");

        const selectedCookie = getCookie("selected-title");
        const selectedCookieInd = getCookie("selected-industry");

        if (selectedCookie != "" && selectedCookieInd != "") {
            if (selectedIndustries) {
                const selectedSpan = selectedIndustries.querySelector("p.select-confirmation span");
                if (selectedSpan) {
                    if (unselectedIndustries) {
                        unselectedIndustries.classList.add("collapse");
                    }
                    if (mobileIndustries) {
                        mobileIndustries.classList.add("collapse");
                    }
                    if (mobileQuestion) {
                        mobileQuestion.classList.add("d-none");
                    }
                    selectedIndustries.classList.add("show");
                    selectedSpan.innerHTML = selectedCookie;
                    if (industrySlideoutTitle) {
                        industrySlideoutTitle.innerHTML = selectedCookie;
                        updateSlider(selectedCookieInd);
                    }
                    toggleSlideout("open");
                }
            }
        }

        if (industryButtons) {
            industryButtons.forEach(function (button) {
                button.addEventListener("click", function (e) {
                    const elem = e.currentTarget;
                    if (selectedIndustries) {
                        const selectedSpan = selectedIndustries.querySelector("p.select-confirmation span");
                        if (selectedSpan) {
                            if (unselectedIndustries) {
                                unselectedIndustries.classList.add("collapse");
                            }
                            if (mobileIndustries) {
                                mobileIndustries.classList.add("collapse");
                                mobileIndustries.classList.remove("show");
                            }
                            if (mobileQuestion) {
                                mobileQuestion.classList.add("d-none");
                            }
                            selectedIndustries.classList.add("show");
                            selectedSpan.innerHTML = elem.dataset.title;

                            if (industrySlideoutTitle) {
                                industrySlideoutTitle.innerHTML = elem.dataset.title;
                                updateSlider(elem.dataset.industry);
                            }
                            if (getCookie("selected-industry") == "") {
                                setCookie("selected-industry", elem.dataset.industry, 30);
                                toggleSlideout("open");
                            }
                            if (getCookie("selected-title") == "") {
                                setCookie("selected-title", elem.dataset.title, 30);
                                toggleSlideout("open");
                            }
                        }
                    }
                });
            });
        }

        if (resetIndustries) {
            resetIndustries.addEventListener("click", function () {
                if (unselectedIndustries) {
                    unselectedIndustries.classList.remove("collapse");
                }
                if (mobileIndustries) {
                    mobileIndustries.classList.remove("collapse");
                }
                if (mobileQuestion) {
                    mobileQuestion.classList.remove("d-none");
                }
                if (selectedIndustries) {
                    selectedIndustries.classList.remove("show");
                    setCookie("selected-industry", "", -30);
                    setCookie("selected-title", "", -30);
                    toggleSlideout("close");
                }
            });
        }

        function toggleSlideout(flag = "open") {
            const slideOut = document.querySelector(".slideout");
            if (slideOut) {
                const industrySlideout = document.querySelector(
                    ".industry-slideout__wrapper"
                );
                if (industrySlideout) {
                    const offsetPadding = 0;
                    if (flag === "close") {
                        slideOut.style.height = "1px";
                    } else {
                        setTimeout(function () {
                            slideOut.style.height =
                                industrySlideout.offsetHeight -
                                offsetPadding +
                                "px";
                        }, 200);
                    }
                }
            }
        }

        function updateSlider(ind) {
            const slideoutData = window.slideoutData;
            if (slideoutData) {
                slideoutData.forEach((data) => {
                    if (data.industry === ind) {
                        document
                            .querySelectorAll(".industry-slideout-title")
                            .forEach((ele) => {
                                ele.innerHTML = data.title;
                            });
                        document
                            .querySelectorAll(".industry-slideout-spiel")
                            .forEach((ele) => {
                                ele.innerHTML = data.spiel;
                            });
                        document
                            .querySelectorAll(".industry-slideout-link")
                            .forEach((ele) => {
                                ele.href = data.link;
                            });
                        document
                            .querySelectorAll(".slideout_image_1")
                            .forEach((ele) => {
                                ele.src = data.slide_image_1;
                            });
                        document
                            .querySelectorAll(".slideout_image_2")
                            .forEach((ele) => {
                                ele.src = data.slide_image_2;
                            });
                        document
                            .querySelectorAll(".slideout_image_3")
                            .forEach((ele) => {
                                ele.src = data.slide_image_3;
                            });
                        document
                            .querySelectorAll(".slideout_image_4")
                            .forEach((ele) => {
                                ele.src = data.slide_image_4;
                            });
                        document
                            .querySelectorAll(".slideout_image_title_1")
                            .forEach((ele) => {
                                ele.innerHTML = data.slide_title_1;
                            });
                        document
                            .querySelectorAll(".slideout_image_title_2")
                            .forEach((ele) => {
                                ele.innerHTML = data.slide_title_2;
                            });
                        document
                            .querySelectorAll(".slideout_image_title_3")
                            .forEach((ele) => {
                                ele.innerHTML = data.slide_title_3;
                            });
                        document
                            .querySelectorAll(".slideout_image_title_4")
                            .forEach((ele) => {
                                ele.innerHTML = data.slide_title_4;
                            });
                        document
                            .querySelectorAll(".slideout_description_1")
                            .forEach((ele) => {
                                ele.innerHTML = data.slide_description_1;
                            });
                        document
                            .querySelectorAll(".slideout_description_2")
                            .forEach((ele) => {
                                ele.innerHTML = data.slide_description_2;
                            });
                        document
                            .querySelectorAll(".slideout_description_3")
                            .forEach((ele) => {
                                ele.innerHTML = data.slide_description_3;
                            });
                        document
                            .querySelectorAll(".slideout_description_4")
                            .forEach((ele) => {
                                ele.innerHTML = data.slide_description_4;
                            });
                        document
                            .querySelectorAll(".slideout_link_1")
                            .forEach((ele) => {
                                ele.href = data.slide_link_1;
                            });
                        document
                            .querySelectorAll(".slideout_link_2")
                            .forEach((ele) => {
                                ele.href = data.slide_link_2;
                            });
                        document
                            .querySelectorAll(".slideout_link_3")
                            .forEach((ele) => {
                                ele.href = data.slide_link_3;
                            });
                        document
                            .querySelectorAll(".slideout_link_4")
                            .forEach((ele) => {
                                ele.href = data.slide_link_4;
                            });
                        document
                            .querySelectorAll(".slideout_tag_1")
                            .forEach((ele) => {
                                ele.innerHTML = data.slide_tag_1;
                            });
                        document
                            .querySelectorAll(".slideout_tag_2")
                            .forEach((ele) => {
                                ele.innerHTML = data.slide_tag_2;
                            });
                        document
                            .querySelectorAll(".slideout_tag_3")
                            .forEach((ele) => {
                                ele.innerHTML = data.slide_tag_3;
                            });
                        document
                            .querySelectorAll(".slideout_tag_4")
                            .forEach((ele) => {
                                ele.innerHTML = data.slide_tag_4;
                            });
                    }
                });
            }
        }
    });


})();
